<p *ngIf="!hide && !loading" class="mb-1" style="font-size: 16px;">{{label}}:
  <strong>{{value}}</strong>
</p>
<ng-container *ngIf="loading">
  <shimmer width="70px" height="16px"></shimmer>
</ng-container>


